import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const RequestDemo = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL(`/contact/` + searchInfo + `#contact-form`);
      window.location.href = pathURL;
    } else {
      window.location.href = `/contact/#contact-form`;
    }
  }, [pathURL]);
  return <div />;
};

export default RequestDemo;
